export const FETCH_ASSET_STATUS_LIST = "FETCH_ASSET_STATUS_LIST";
